exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".img-profile {\n    display: block;\n    /* width: 100%; */\n    height: 200pt;\n    width: 150pt;\n    object-fit: cover;\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./ClientApp/app/components/singleMember-form/singlemember.component.css
// module id = 439
// module chunks = 0